import { render, staticRenderFns } from "./SucCalendarItemComponent.vue?vue&type=template&id=cd814830&scoped=true&"
import script from "./SucCalendarItemComponent.vue?vue&type=script&lang=js&"
export * from "./SucCalendarItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./SucCalendarItemComponent.vue?vue&type=style&index=0&id=cd814830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd814830",
  null
  
)

export default component.exports